// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getDeployment } from '../../redux/modules/config';
import PreprodWarningBanner from './PreprodWarningBanner';

const mapStateToProps = state => {
    const deployment = getDeployment(state);
    return {
        deployment,
    };
};

type Props = {
    deployment: string,
};

export class PreprodWarningBannerContainer extends PureComponent<Props> {
    render() {
        const show = this.props.deployment === 'preprod';

        return show ? <PreprodWarningBanner /> : null;
    }
}

export default connect(mapStateToProps)(PreprodWarningBannerContainer);
